import api from '../../../shared/services/apiClient';
import { User } from '@/types';
import { normalizeUser, showDevWarnings } from '../../../utils/userValidator';

export const login = async (payload: { email: string; password: string; domain?: string }): Promise<User> => {
  const res = await api.post('/auth/login', payload);
  const { accessToken, user } = res.data;
  
  // Validate user structure in development
  showDevWarnings(user);
  
  // Normalize user to ensure 'type' field exists
  const normalizedUser = normalizeUser(user);
  
  if (accessToken) localStorage.setItem('token', accessToken);
  if (normalizedUser) localStorage.setItem('currentUser', JSON.stringify(normalizedUser));
  
  return normalizedUser as any as User;
};

export const logout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('currentUser');
};

export const getToken = () => localStorage.getItem('token');

export default { login, logout, getToken } as any;
